/**
 * Recently-visited bids, kept in localStorage so the left nav's bid switcher can show the
 * member's own last few — not the whole (potentially long) list of every bid they can access.
 *
 * Per-browser, not per-account: same trade as `niobe.navW`/`niobe.chatW` in App.tsx. Storage
 * unavailable (private browsing, quota) degrades to "no recency known" rather than throwing —
 * the switcher then just shows whatever the caller falls back to.
 */

const KEY = 'niobe.recentBids'
/** Kept beyond the 3 the switcher shows, so digging further back via "more…" and returning still
 *  ranks a bid correctly instead of it falling off the moment a handful of others are opened. */
const MAX_STORED = 10

/** Recently-visited bid ids, most-recent-first. */
export function getRecentBidIds(): string[] {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed: unknown = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : []
  } catch {
    return []
  }
}

/** Record a visit to `id`: moves it to the front (deduping any earlier entry), caps the history. */
export function recordBidVisit(id: string): void {
  try {
    const ids = getRecentBidIds().filter((x) => x !== id)
    ids.unshift(id)
    localStorage.setItem(KEY, JSON.stringify(ids.slice(0, MAX_STORED)))
  } catch {
    /* storage unavailable — nothing to persist to */
  }
}
